module.exports = __webpack_public_path__ + "img/alipay.c21984b8.png";